module.exports = __webpack_public_path__ + "img/advantage-title.13c09a11.png";